export default __webpack_public_path__ + "static/media/stage-5-neocortex-high-order-association.2e946dfe.png";